import { ADD_ITEM_TO_CART, CART_DATA_ERROR_RESET, CREATE_BASKETS_REQUEST, CREATE_BASKETS_RESET, DELETE_BASKET, BASKET_DETAILS, UPDATE_ITEM_QUANTITY, REMOVE_LINE_ITEM, REMOVE_All_ITEM, SHOW_CUSTOMIZATION_MODAL, CART_RECOMMENDATION_RULES, GET_APPLICABLE_COUPONS, APPLY_COUPONS, VALIDATE_BASKET_REQUEST, VALIDATE_BASKET_RESET, REMOVE_COUPONS, RESET_CART_DATA, FLAG_NON_LOCALIZED_ADD_TO_CART, GET_NON_LOCALISED_COUPON, GET_LOGGEDIN_NON_LOCALISED_COUPON, RESET_FLAG_NON_LOCALIZED_ADD_TO_CART, UPDATE_LINE_ITEM, SET_USER_LAST_ACTIVE_TIME, RESET_CART_REDUCER, COUPON_COPY, REDEEM_COUPON_COPY, REMOVE_ALL_COUPONS, HIDE_ADD_TO_CART_TOAST, RESET_CART_FAILURE_EMPTY, UPDATE_CUSTOMER_ID, CUSTOMER_ID_UPDATED, ADD_ITEM_QUANTITY, RESET_ITEM_QUANTITY, BULK_UPDATE_ITEM_QUANTITY, QR_CODE_SCAN_TIME, UPDATE_CART_WITH_STORE_AND_DISPOSITION, UPDATE_BASKET_FLAG, ADD_PROMO_CODE, REMOVE_PROMO_CODE, REMOVE_ALL_PROMOS, ADD_EMPLOYEE_PROMO_CODE, REMOVE_EMPLOYEE_PROMO_CODE, SET_PROMOS, SHOW_INDULGENT_ADDONS, HIDE_INDULGENT_ADDONS, CART_RESET, CATEGORY_ITEM_INDEX, UNAVAILABLE_MODIFIERS, REMOVE_MULTIPLE_LINE_ITEM, GET_HIDDEN_COUPON_DETAILS, } from '../../constants';
export function addItemToCartAction(payload, postBody, successCallback = null, errorCallback = null) {
    return {
        type: ADD_ITEM_TO_CART,
        payload,
        postBody,
        successCallback,
        errorCallback,
    };
}
export function cartDataErrorReset() {
    return {
        type: CART_DATA_ERROR_RESET,
    };
}
export function createBasketsAction(payload) {
    return {
        type: CREATE_BASKETS_REQUEST,
        payload: payload,
    };
}
export function resetBasketAction() {
    return {
        type: CREATE_BASKETS_RESET,
    };
}
export function hideAddtoCartToadAction() {
    return {
        type: HIDE_ADD_TO_CART_TOAST,
    };
}
export function deleteBasketsAction(payload, shouldCreateBasket = false, createBasketParams = {}) {
    return {
        type: DELETE_BASKET,
        payload,
        shouldCreateBasket,
        createBasketParams,
    };
}
export function basketDetailsAction(payload, postBody) {
    return {
        type: BASKET_DETAILS,
        payload,
        postBody,
    };
}
export function updateItemQuantityAction(payload, postBody, isItemAdded = false, successCallback = null, errorCallback = null) {
    return {
        type: UPDATE_ITEM_QUANTITY,
        payload,
        postBody,
        isItemAdded,
        successCallback,
        errorCallback,
    };
}
export function updateLineitemAction(payload, postBody, successCallback = null, errorCallback = null) {
    return {
        type: UPDATE_LINE_ITEM,
        payload,
        postBody,
        successCallback,
        errorCallback,
    };
}
export function removeLineItemAction(payload, postBody) {
    return {
        type: REMOVE_LINE_ITEM,
        payload,
        postBody,
    };
}
export function removeMultipleLineItemAction(payload, postBody) {
    return {
        type: REMOVE_MULTIPLE_LINE_ITEM,
        payload,
        postBody,
    };
}
export function removeAllItemAction(payload, postBody, successCallBack = null) {
    return {
        type: REMOVE_All_ITEM,
        payload,
        postBody,
        successCallBack
    };
}
export function showCustomizationModalAction(payload) {
    return {
        type: SHOW_CUSTOMIZATION_MODAL,
        payload,
    };
}
export function getAllRecommendationRules(payload, flatResponse) {
    return {
        type: CART_RECOMMENDATION_RULES,
        payload,
        flatResponse,
    };
}
export function getApplicableCouponsAction(payload) {
    return {
        type: GET_APPLICABLE_COUPONS,
        payload,
    };
}
export function applyCoupon(payload, postBody) {
    return {
        type: APPLY_COUPONS,
        payload,
        postBody,
    };
}
export function removeCouponAction(payload, successCallBack = null) {
    return {
        type: REMOVE_COUPONS,
        payload,
        successCallBack,
    };
}
export function removeAllCouponAction(payload, postBody, successCallBack = null) {
    return {
        type: REMOVE_ALL_COUPONS,
        payload,
        postBody,
        successCallBack,
    };
}
export function validateBasketAction(payload, successCallback, errorCallback) {
    return {
        type: VALIDATE_BASKET_REQUEST,
        payload,
        successCallback,
        errorCallback,
    };
}
export function resetValidateBasketAction() {
    return {
        type: VALIDATE_BASKET_RESET,
    };
}
export function resetCartToInitialState() {
    return {
        type: RESET_CART_DATA,
    };
}
export function setFlagNonLocalizedAddCartAction(payload) {
    return {
        type: FLAG_NON_LOCALIZED_ADD_TO_CART,
        payload,
    };
}
export function getNonLocalisedCouponsAction(payload) {
    return {
        type: GET_NON_LOCALISED_COUPON,
        payload,
    };
}
export function getLoggedinNonLocalizedCoupon(payload) {
    return {
        type: GET_LOGGEDIN_NON_LOCALISED_COUPON,
        payload,
    };
}
export function resetFlagNonLocalizedAddCartAction() {
    return {
        type: RESET_FLAG_NON_LOCALIZED_ADD_TO_CART,
    };
}
export function setUserLastActiveTime(currentTime) {
    return {
        type: SET_USER_LAST_ACTIVE_TIME,
        currentTime,
    };
}
export function resetCartReducer() {
    return {
        type: RESET_CART_REDUCER,
    };
}
export function updateBasketFlag(isBasketFlag) {
    return {
        type: UPDATE_BASKET_FLAG,
        isBasketFlag,
    };
}
export function couponCopyAction(payload) {
    return {
        type: COUPON_COPY,
        payload,
    };
}
export function redeemCouponCopyAction(payload) {
    return {
        type: REDEEM_COUPON_COPY,
        payload,
    };
}
export function resetCartEmptyFlagAction() {
    return {
        type: RESET_CART_FAILURE_EMPTY,
    };
}
export function storeUnavaliableModifiers(payload) {
    return {
        type: UNAVAILABLE_MODIFIERS,
        payload,
    };
}
export function updateCustomerID(payload) {
    return {
        type: UPDATE_CUSTOMER_ID,
        payload,
    };
}
export function setCustomerIdUpdated(payload) {
    return {
        type: CUSTOMER_ID_UPDATED,
        payload,
    };
}
export function addItemsQuantity(payload) {
    return {
        type: ADD_ITEM_QUANTITY,
        payload,
    };
}
export function resetItemQuantity() {
    return {
        type: RESET_ITEM_QUANTITY,
    };
}
export function bulkupdateItemQuantityAction(payload) {
    return {
        type: BULK_UPDATE_ITEM_QUANTITY,
        payload,
    };
}
export function qrCodeScanTimeAction(time = null) {
    return {
        type: QR_CODE_SCAN_TIME,
        time,
    };
}
export function updateStoreWithDisposition(payload, successCallback) {
    return {
        type: UPDATE_CART_WITH_STORE_AND_DISPOSITION,
        payload,
        successCallback,
    };
}
export function addPromoCodeAction(payload) {
    return {
        type: ADD_PROMO_CODE,
        payload,
    };
}
export function removePromoCodeAction() {
    return {
        type: REMOVE_PROMO_CODE,
    };
}
export function addEmployeePromoCodeAction(payload) {
    return {
        type: ADD_EMPLOYEE_PROMO_CODE,
        payload,
    };
}
export function removeEmployeePromoCodeAction() {
    return {
        type: REMOVE_EMPLOYEE_PROMO_CODE,
    };
}
export function removeAllPromosAction() {
    return {
        type: REMOVE_ALL_PROMOS,
    };
}
export function setPromos(bool) {
    return {
        type: SET_PROMOS,
        bool,
    };
}
export function showIndulgentAddOns() {
    return {
        type: SHOW_INDULGENT_ADDONS,
    };
}
export function hideIndulgentAddOns() {
    return {
        type: HIDE_INDULGENT_ADDONS,
    };
}
export const cartClearReducer = () => ({
    type: CART_RESET,
});
export function selectedCategariItemIndex(i) {
    return {
        type: CATEGORY_ITEM_INDEX,
        i,
    };
}
export function getHiddenCouponDetails(payload) {
    return {
        type: GET_HIDDEN_COUPON_DETAILS,
        payload,
    };
}
